import { UnversalModal } from "../universal-modal/universal-modal";

export default{
    init(){
        this.initFilters();
        this.initPagination();
        this.initDateFilter();
        this.initStartLoading();
        this.initSortFields();
        this.activitiesModalOpening();
    },
    initStartLoading(){
        $('body').on('click', '.stafter-table-modals .tag.activity', (e)=>{
            this.updateActivitiesTable(e.currentTarget, 0);
        })
    },
    initDateFilter(){
        $('#activities-range').daterangepicker();
        $('body').on('click', '.stafter-table-modals #activities-range', () => {
            $('#activities-range').off('cancel.daterangepicker').on('cancel.daterangepicker', (e,p)=>{
                $(e.currentTarget).val('');
                this.updateActivitiesTable(e.currentTarget);
            });
            $('#activities-range').off('apply.daterangepicker').on('apply.daterangepicker', (e,p)=>{
                this.updateActivitiesTable(e.currentTarget);
            });
        });
    },
    initFilters(){
        $('body').on('input', '.stafter-table-modals .info-block.activity input#reference-id', (e)=>{
            this.updateActivitiesTable(e.currentTarget);
        });
        $('body').on('change', '.stafter-table-modals .info-block.activity select#activity-select, .stafter-table-modals .info-block.activity select#table_size, .stafter-table-modals .info-block.activity #activity-status-select', (e)=>{
            if ($(e.currentTarget).attr('id') == 'activity-select') {
                $('.stafter-table-modals .info-block.activity #activity-status-select').val('')
            }
            this.updateActivitiesTable(e.currentTarget);
        });
    },
    initPagination(){
        $('body').on('click', '.stafter-table-modals .info-block.activity .stafter-table-paginator-page', (e)=>{
            this.updateActivitiesTable(e.target, 100);
        });
    },
    updateActivitiesTable(element, timeout = 1000, sort_field=null,sort_direction=null ){
        const timeout_id = setTimeout(() => {
            let parent_block;
            if ($(element).hasClass('tag')) {
                parent_block = $(element).parents('.modal').find('.info-block.activity');
            } else {
                parent_block = $(element).parents('.info-block');
            }
            const customer_id = parent_block.find('#cust_id').val();
            let page_number = 1;
            if ($(element).hasClass('stafter-table-paginator-page')) {
                if ($(element).hasClass('page-number')) {
                    page_number = $(element).text();
                } else {
                    page_number = parent_block.find('.stafter-table-paginator-page.page-number.active').text();
                    page_number = $(element).hasClass('next') ? page_number+1 : page_number-1;
                }
            }
            if (!sort_field) {
                sort_field = parent_block.find('th .sorted').data('field');
            }
            if(!sort_direction){
                sort_direction = parent_block.find('th .sorted').data('dir');
            }

            const filter_data = {
                page_number: page_number,
                list_size: parent_block.find('#table_size').val(),
                sort_field: sort_field,
                sort_direction: sort_direction,
                search_params: this.collectSearchData(parent_block),
            }
            this.getTableByFilters(filter_data, customer_id, parent_block);
        }, timeout);
        clearTimeout(timeout_id-1);
    },
    getTableByFilters(filter_data, customer_id, parent_block){
        $.ajax({
            method: "POST",
            url: `/customers/get-customer-activities/${customer_id}`,
            data: filter_data,
            beforeSend: () =>{
                parent_block.find('.loader-wrapper').show();
            },
            success: (r) => {
                parent_block.find('.table-container').html(r.view);
                let status_select = parent_block.find('#activity-status-select');
                if (r.statuses) {
                    let def_option = "<option value=''>Show All Statuses</option>";
                    status_select.html('');
                    status_select.append(def_option);
                    Object.entries(r.statuses).forEach(([key, value]) => {
                        let selected = '';
                        if (key === r.current_status) {
                            selected = 'selected';
                        }
                        status_select.append(`<option value="${key}" ${selected}>${value}</option>`);
                    });
                    status_select.removeAttr('disabled');
                }else{
                    status_select.attr('disabled','true');
                }
            },
            error: (r) => {
                console.log(r);
            },
            complete: (r) => {
                parent_block.find('.loader-wrapper').hide();
            }
        });
    },
    collectSearchData(parent_block){
        return {
            reference_id:parent_block.find('#reference-id').val(),
            activity: parent_block.find('#activity-select').val(),
            date_range: parent_block.find('#activities-range').val(),
            status: parent_block.find('#activity-status-select').val()
        }
    },
    initSortFields(){
        $('body').on('click', '.stafter-table-modals .info-block.activity .sortable-header', (e)=>{
            let field = $(e.currentTarget).data('field');
            let dir = 'asc';
            if ($(e.currentTarget).hasClass('sorted')) {
                dir = $(e.currentTarget).data('dir') == 'asc' ? 'desc' : 'asc';
            } else {
                dir = $(e.currentTarget).data('dir');
            }
            this.updateActivitiesTable(e.currentTarget, 1000, field, dir);
        });
    },
    activitiesModalOpening(){
        $('body').on('click', '.stafter-table-modals .info-block.activity .activity-row', (e)=>{
            const row = $(e.currentTarget);
            const activity = row.data('activity');
            const customerId = parseInt(row.attr('data-customer_local_id'), 10);
            const parentId = parseInt(row.attr('data-parent_id'), 10);
            const parentLocalId = parseInt(row.attr('data-parent_local_id'), 10);
            const rawEntityId = row.attr('data-entity_id');
            const rawEntityLocalId = row.attr('data-entity_local_id');
            const entityId = rawEntityId ? parseInt(rawEntityId, 10) : null;
            const entityLocalId = rawEntityLocalId ? parseInt(rawEntityLocalId, 10) : null;

            if (!Number.isInteger(customerId) || !Number.isInteger(parentId) || !Number.isInteger(parentLocalId)) {
                console.warn('activity-row: missing local record context');
                return;
            }

            const step = activity === 'appointment' || activity === 'payment'
                ? 'appointments'
                : 'projects';
            const modal = new UnversalModal(customerId);
            modal.openModal(step, activity, parentId, entityId, {
                parentLocalId,
                entityLocalId,
            });
        });
    },
    getAppointmentModal(order_id){
        if (Number.isInteger(order_id)) {
            $.ajax({
                url: `/get-order-modal/${order_id}`,
                method: "POST",
                dataType: 'html',
                success: (response) => {
                    $('#form-container-s').find(`#appointment-${order_id}`).remove();
                    $('#form-container-s').append(response);
                    $(`#appointment-${order_id}`).modal('show')
                },
                error: ()=>{

                }
            });
        }
    },
    getPaymentModal(payment_id){
        if (Number.isInteger(payment_id)) {
            $.ajax({
                url: `/get-payment-modal/${payment_id}`,
                method: "POST",
                dataType: 'html',
                success: (response) => {
                    $('#form-container-s').find(`#payments-appointments-${order_id}`).remove();
                    $('#form-container-s').append(response);
                    $(`#payments-appointments-${order_id}`).modal('show')
                },
                error: ()=>{

                }
            });
        }
    }
}
